import { render, staticRenderFns } from "./AppVamoMexe.vue?vue&type=template&id=8b4699a2&"
import script from "./AppVamoMexe.vue?vue&type=script&lang=js&"
export * from "./AppVamoMexe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports